module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/e9049f5e7574edf1dbc63410dd94e9e9.svg";